import React, { useEffect } from "react";
import { useGetTablesdataMutation } from "./TablesourceApiSlice";
import { useGetPostgresqlTablesPreviewdataMutation } from "./sqlApiSlice";
import { useLocation } from "react-router-dom";

const TableSource = ({ selectedTable, connectionId }) => {
  const [
    getTablesdata,
    {
      data: mysqlData,
      isLoading: isLoadingMySQL,
      isError: isErrorMySQL,
      isSuccess: isSuccessMySQL,
    },
  ] = useGetTablesdataMutation();

  const [
    getTablesSqlPreviewdata,
    {
      data: datapreview,
      isLoading: isLoadingpreview,
      isError: isErrorpreview,
      isSuccess: isSuccesspreview,
    },
  ] = useGetPostgresqlTablesPreviewdataMutation();

  const location = useLocation();
  const databaseType = location?.state?.dbType;
  // console.log("DB Type:", databaseType);

  useEffect(() => {
    if (!selectedTable || !connectionId || !databaseType) return;

    if (databaseType === "mysql") {
      getTablesdata({ selectedTable, connectionId });
    } else if (databaseType === "postgresql") {
      getTablesSqlPreviewdata({ tableName: selectedTable, connectionId });
    }
  }, [selectedTable, connectionId, databaseType]);

  let TableContent;

  if (isLoadingMySQL || isLoadingpreview) {
    TableContent = <p>Loading...</p>;
  } else if (isErrorMySQL || isErrorpreview) {
    const errorMessage =
      (isErrorMySQL && mysqlData?.error?.message) ||
      (isErrorMySQL && mysqlData?.data?.message) ||
      (isErrorpreview && datapreview?.error?.message) ||
      (isErrorpreview && datapreview?.data?.message);

    TableContent = <p className="text-red-500">{errorMessage}</p>;
  } else if (databaseType === "mysql" && isSuccessMySQL) {
    const { mappedColumnArray, data: tableData } = mysqlData || {};

    if (!Array.isArray(mappedColumnArray) || mappedColumnArray.length === 0) {
      TableContent = <p>No columns available</p>;
    } else if (!Array.isArray(tableData) || tableData.length === 0) {
      TableContent = <p>No data available</p>;
    } else {
      TableContent = renderTable(mappedColumnArray, tableData);
    }
  } else if (databaseType === "postgresql" && isSuccesspreview) {
    const tableData = datapreview?.data || [];
    const columns = tableData.length ? Object.keys(tableData[0]) : [];

    if (columns.length === 0) {
      TableContent = <p>No columns available</p>;
    } else if (tableData.length === 0) {
      TableContent = <p>No data available</p>;
    } else {
      // Construct column array similar to mappedColumnArray
      const mappedColumnArray = columns.map((col) => ({ columnName: col }));
      TableContent = renderTable(mappedColumnArray, tableData);
    }
  }

  return TableContent || <p className="text-gray-500">No selected table</p>;
};

const renderTable = (columns, data) => (
  <div className="w-full h-[30rem] lg:h-full lg:w-[70%]">
    <h2 className="font-medium mb-2">Data Preview:</h2>
    <div className="h-[99%] overflow-hidden overflow-y-auto ">
      <table className="border border-gray-300 border-collapse w-full text-sm">
        <thead className="bg-gray-100 text-left sticky top-0">
          <tr>
            {columns.map((col, index) => (
              <th key={index} className="p-2 bg-gray-200 font-bold">
                {col.columnName}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((rowData, rowIndex) => (
            <tr
              key={rowIndex}
              className={`border-b  border-gray-300 ${rowIndex % 2 === 0 ? "bg-gray-100" : "bg-white"
                }`}
            >
              {columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  className="p-2 border border-gray-300 truncate"
                >
                  {rowData[col.columnName]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default TableSource;
